import defaultMessages from 'ra-language-english';
export default (function () {
  return defaultMessages;
});